import { type EditorPlugin } from '../../types/aha-editor';

const LabelPillSchemaPlugin: EditorPlugin = {
  id: 'labelPillSchema',
  name: 'Label pill schema plugin',
  schema: {
    pill: {
      isInline: true,
    },
  },
};

export default LabelPillSchemaPlugin;
